import React from 'react';
import Badge from '../../components/Badge';
import Tooltip from '../../components/Tooltip';
import styles from './ProvisionSSODefaultBadge.module.scss';

const ProvisionSSODefaultBadge = () => (
  <div className={styles.badge}>
    <Tooltip
      placement="top"
      tooltip="This provision is assigned to new users who sign up via SSO, unless they are manually assigned a provision when invited."
      trigger="hover"
    >
      <Badge color="gray">SSO Default</Badge>
    </Tooltip>
  </div>
);

export default ProvisionSSODefaultBadge;
